import { PayrollReportSummaryDTO } from '@iota/inh-core-v1-management-client';
import { createAction, props } from '@ngrx/store';

export const LoadAllPayrollReportSummaries = createAction('[PayrollReportSummary] LoadAllPayrollReportSummaries');
export const LoadAllPayrollReportSummariesSuccess = createAction(
    '[PayrollReportSummary] LoadAllPayrollReportSummariesSuccess',
    props<{ payrollReports: PayrollReportSummaryDTO[] }>()
);
export const LoadAllPayrollReportSummariesFailure = createAction(
    '[PayrollReportSummary] LoadAllPayrollReportSummariesFailure',
    props<{ error: any }>()
);

export const ApprovePayrollReportSummary = createAction(
    '[PayrollReportSummary] ApprovePayrollReportSummary',
    props<{ payrollReportSummaryId: string }>()
);
export const RejectPayrollReportSummary = createAction(
    '[PayrollReportSummary] RejectPayrollReportSummary',
    props<{ payrollReportSummaryId: string }>()
);

export const PayrollReportSummaryActionSuccess = createAction(
    '[PayrollReportSummary] PayrollReportSummaryActionSuccess',
    props<{ payrollReport: PayrollReportSummaryDTO }>()
);
export const PayrollReportSummaryActionFailure = createAction(
    '[PayrollReportSummary] PayrollReportSummaryActionFailure',
    props<{ payrollReportSummaryId: string; error: any }>()
);
export const AddPayrollReportSummaryNote = createAction(
    '[PayrollReportSummary] CreatePayrollReportSummaryNote',
    props<{ payrollReportSummaryId: string; note: string }>()
);
export const RemovePayrollReportSummaryNote = createAction(
    '[PayrollReportSummary] RemovePayrollReportSummaryNote',
    props<{ payrollReportSummaryId: string; noteId: string }>()
);
